import { useMutation } from '@apollo/client';
import React from 'react';
import * as styles from './LoginPasswordFormView.module.scss';
import Form, { Field, Submit } from '../../components/Form';
import { gql } from '../../graphql/generated/gql';
import Link from '../../utils/router/Link';
import usePostLoginHandler from '../usePostLoginHandler';

const PASSWORD_LOGIN_MUTATION = gql(/** @complexity 2 */ `
  mutation passwordLogin($email: String!, $password: String!) {
    session: passwordLogin(email: $email, password: $password) {
      authToken
    }
  }
`);

type LoginPasswordValues = { email: string; password: string };

const LoginPasswordFormView = () => {
  const [passwordLogin] = useMutation(PASSWORD_LOGIN_MUTATION);

  const postLoginHandler = usePostLoginHandler();

  const onSubmit = (values: LoginPasswordValues) =>
    passwordLogin({ variables: values }).then(({ data }) => {
      if (data?.session) {
        postLoginHandler(data.session.authToken);
      }
    });

  return (
    <Form<LoginPasswordValues>
      apiErrorMessages={{
        BAD_PASSWORD:
          'Email and password did not match. Did you mistype one of them?',
        SSO_ONLY: 'Please use Single Sign-On to log in.',
        UNVERIFIED_ORGANIZATION:
          'You need to verify your email before logging in.',
        USER_DEACTIVATED: 'This account has been deactivated.',
      }}
      initialValues={{ email: '', password: '' }}
      onSubmit={onSubmit}
    >
      <Field
        name="email"
        type="email"
        placeholder="Your email"
        required
        autoComplete="email username"
        margin="compact"
      />
      <Field
        name="password"
        type="password"
        placeholder="Password"
        required
        autoComplete="current-password"
        margin="compact"
      />
      <Submit block>Log in</Submit>
      <Link className={styles.forgotLink} to="/forgot">
        Forgot your password?
      </Link>
    </Form>
  );
};

export default LoginPasswordFormView;
